import { render } from "./Content.vue?vue&type=template&id=0dd3636a"
import script from "./Content.vue?vue&type=script&lang=ts"
export * from "./Content.vue?vue&type=script&lang=ts"
script.render = render

export default script